import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsOptimizeCFOptionsRoute: InvariantJiraRoute = {
	name: 'global-settings-optimize-cf-options-view',
	path: '/jira/settings/issues/custom-fields/:cfId/options/optimize',
};
